export const DEFAULT_SERVICE_ICON_URL_GREY =
  'https://cdn.zapier.com/zapier/images/frontend/placeholder/128x128.grey.png';
export const DEFAULT_SERVICE_ICON_URL_ORANGE =
  'https://cdn.zapier.com/zapier/images/frontend/placeholder/128x128.png';

// FROM HERE KEEP IN SYNC WITH `web/backend/zapier/support/constants.py`

/** The path where we guide users to get help */
export const GET_HELP_PATH = '/app/get-help';

/** The phrasing we use when directing users to the above */
export const GET_HELP_CTA = 'get help';

// Help center
export const HELP_CENTER = 'https://help.zapier.com/hc/en-us';
